"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof3 = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/slicedToArray.js"));

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.find");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

var _typeof2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js"));

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.function.name");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _contract = require("@/api/cms/contract");

var _order = require("@/api/cms/order");

var _designSchemeApi = require("@/api/designSchemeApi");

var _syncQwDept = require("@/api/cms/syncQwDept");

var _auth = require("@/utils/auth");

var _vuex = require("vuex");

var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));

require("@riophae/vue-treeselect/dist/vue-treeselect.css");

var _userSelect = _interopRequireDefault(require("@/views/cms/common/userSelect"));

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'ModifySupplementEdit',
  components: {
    UserSelect: _userSelect.default,
    Treeselect: _vueTreeselect.default
  },
  dicts: ['after_problem_type'],
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['filesUploadApi'])), {}, {
    isReadOnly: function isReadOnly() {
      return this.$route.name === 'ModifySupplementDetail' || this.$route.query.readOnly === '1';
    },
    getAmendType: function getAmendType() {
      var contractNo = this.contract.contractNo || '';
      var last4 = contractNo.slice(-4);
      if (/[Bb]/.test(last4)) return '补单';
      if (/[Gg]/.test(last4)) return '改单';
      return '-';
    },
    // 判责与物料修改：非只读详情页均可编辑（提交后仍可编辑，编辑后保存即生效）
    canEditJudgment: function canEditJudgment() {
      return !this.isReadOnly;
    },
    // 合同状态为86（待经销商确认）时：隐藏提交按钮，显示确认付款按钮
    // contractStatus 在合同信息 contract 中
    isDealerConfirm: function isDealerConfirm() {
      return Number(this.contract.contractStatus) === 86;
    },
    // 确认付款模块是否允许操作：仅合同状态86（待经销商确认）且未付款（付款时间为空）时可操作
    canEditPay: function canEditPay() {
      return this.isDealerConfirm && !this.afterInfo.payTime;
    },
    // 确认收款模块是否允许操作：已付款未收款（付款时间非空、收款时间为空）时可操作
    canEditReceive: function canEditReceive() {
      return !!this.afterInfo.payTime && !this.afterInfo.receiveTime;
    },
    // 跟进附件回显列表（uploadServiceFiles 为 JSON 字符串数组）
    serviceFileList: function serviceFileList() {
      return this.parseFiles(this.uploadServiceFiles);
    },
    // 跟进附件中图片的预览地址列表
    serviceFileImageList: function serviceFileImageList() {
      var _this = this;

      return this.serviceFileList.filter(function (f) {
        return _this.isImageFile(f);
      }).map(function (f) {
        return _this.getFileUrl(f);
      });
    }
  }),
  data: function data() {
    return {
      headers: {
        'Authorization': (0, _auth.getToken)()
      },
      cardBodyStyle: {
        padding: '12px 16px'
      },
      loading: false,
      saveLoading: false,
      submitted: false,
      materialTab: 'original',
      contract: {},
      afterInfo: {
        problemCause: '',
        problemNow: '',
        problemDescription: '',
        amendmentType: '',
        requiredInboundTime: '',
        requiredDeliveryDate: '',
        requiredInstallationDate: '',
        auditRemark: '',
        serviceRemark: '',
        serviceFile: '',
        problemImg: '',
        file: '',
        otherFile: '',
        changeStatus: '',
        contactPerson: '',
        contactAddress: '',
        contactNumber: '',
        subStatus: '',
        assignUserName: '',
        assignNickName: '',
        payNickName: '',
        payTime: '',
        chargeAmount: null,
        paymentProof: '',
        payRemark: '',
        receiveNickName: '',
        receiveTime: '',
        receiveAmount: null
      },
      // 处理人选择
      showUserSelect: false,
      // 跟进信息（跟进备注/跟进附件）保存中
      serviceSaveLoading: false,
      // 跟进附件上传
      serviceFileUploadList: [],
      uploadServiceFiles: [],
      // 付款凭证上传
      paymentProofUploadList: [],
      uploadPaymentProofs: [],
      // 付款二维码
      showPayQrDialog: false,
      payQrUrl: 'https://oss.aiggf.cn/upload/image/eebd26f4a5964818a59efbd709ccca71.png',
      // 报价信息
      showQuoteDialog: false,
      quoteLoading: false,
      quoteList: [],
      quoteTotal: 0,
      originalMaterialList: [],
      otherMaterialList: [],
      kujialeMaterialList: [],
      // 各物料表的勾选行：{ original|other|kujiale: { [gIdx]: rows[] } }
      materialSelection: {
        original: {},
        other: {},
        kujiale: {}
      },
      syncBomLoading: false,
      batchOriginalForm: {
        problemType: '',
        dutyPerson: '',
        dutyPersonId: '',
        dutyDept: '',
        dutyDeptId: '',
        finalDept: '',
        finalDeptId: '',
        finalPerson: '',
        finalPersonId: '',
        chargeType: '',
        dutyPersonTouched: false,
        finalPersonTouched: false
      },
      batchOtherForm: {
        problemType: '',
        dutyPerson: '',
        dutyPersonId: '',
        dutyDept: '',
        dutyDeptId: '',
        finalDept: '',
        finalDeptId: '',
        finalPerson: '',
        finalPersonId: '',
        chargeType: '',
        dutyPersonTouched: false,
        finalPersonTouched: false
      },
      batchKujialeForm: {
        problemType: '',
        dutyPerson: '',
        dutyPersonId: '',
        dutyDept: '',
        dutyDeptId: '',
        finalDept: '',
        finalDeptId: '',
        finalPerson: '',
        finalPersonId: '',
        chargeType: '',
        dutyPersonTouched: false,
        finalPersonTouched: false
      },
      batchKujialeLoading: false,
      // 责任部门（企业微信部门树）
      dutyDeptTree: [],
      dutyDeptTreeLoaded: false,
      dutyDeptIdNameMap: {},
      dutyDeptNameIdMap: {},
      // 各部门下的用户（责任部门 -> 责任人下拉）
      dutyDeptUsers: {},
      dutyDeptUsersLoading: {},
      // O(1) 查找表：用户ID<->姓名（避免每次在全部部门列表里扫描导致越选越卡）
      userIdNameMap: {},
      userNameIdMap: {}
    };
  },
  activated: function activated() {
    this.loadPageData();
    this.loadDutyDeptTree(); // 预取全部人员，保证未选部门时责任人下拉也有数据

    this.loadDeptUsers();

    if (this.isReadOnly) {
      this.submitted = true;
    }
  },
  methods: {
    loadPageData: function loadPageData() {
      var contractId = this.$route.query.id; // 从 query 中读取原单信息（作为 API 数据的兜底）

      var queryContract = {
        contractNo: this.$route.query.contractNo || '',
        originalContractNo: this.$route.query.originalContractNo || '',
        custName: this.$route.query.custName || '',
        custMobile: this.$route.query.custMobile || '',
        custAddress: this.$route.query.custAddress || '',
        province: this.$route.query.province || '',
        city: this.$route.query.city || '',
        district: this.$route.query.district || '',
        orderClerkNickName: this.$route.query.orderClerkNickName || '',
        designerNickName: this.$route.query.designerNickName || '',
        guideNickName: this.$route.query.guideNickName || '',
        dealerShopName: this.$route.query.dealerShopName || '',
        storeName: this.$route.query.storeName || '',
        msgFrom: this.$route.query.msgFrom || '',
        channelType: this.$route.query.channelType || '',
        installMamager: this.$route.query.installMamager || '',
        installGroup: this.$route.query.installGroup || '',
        installPerson: this.$route.query.installPerson || '',
        installFinishTime: this.$route.query.installFinishTime || '',
        actualFinishingDate: this.$route.query.actualFinishingDate || '',
        submitUser: this.$route.query.submitUser || '',
        signingTime: this.$route.query.signingTime || '',
        createdatetime: this.$route.query.createdatetime || '',
        contractStatus: this.$route.query.contractStatus != null ? this.$route.query.contractStatus : ''
      };
      this._queryContract = queryContract;
      this.contract = _objectSpread({}, queryContract);

      if (contractId) {
        this.loadData(contractId);
      }
    },
    loadData: function loadData(contractId) {
      var _this2 = this;

      // 清空旧数据，避免显示缓存
      this.afterInfo = {
        problemCause: '',
        problemNow: '',
        problemDescription: '',
        amendmentType: '',
        requiredInboundTime: '',
        requiredDeliveryDate: '',
        requiredInstallationDate: '',
        auditRemark: '',
        serviceRemark: '',
        serviceFile: '',
        problemImg: '',
        file: '',
        otherFile: '',
        changeStatus: '',
        contactPerson: '',
        contactAddress: '',
        contactNumber: '',
        subStatus: '',
        assignUserName: '',
        assignNickName: '',
        payNickName: '',
        payTime: '',
        chargeAmount: null,
        paymentProof: '',
        payRemark: '',
        receiveNickName: '',
        receiveTime: '',
        receiveAmount: null
      };
      this.serviceFileUploadList = [];
      this.uploadServiceFiles = [];
      this.paymentProofUploadList = [];
      this.uploadPaymentProofs = [];
      this.originalMaterialList = [];
      this.otherMaterialList = [];
      this.kujialeMaterialList = [];
      this.materialTab = this.getAmendType === '改单' ? 'kujiale' : 'original';
      this.submitted = false;
      this.loading = true;
      var promises = []; // 加载合同改补信息

      promises.push((0, _contract.getContractAfterInfo)(contractId).then(function (response) {
        if (response.code === 200 && response.data) {
          var data = response.data;
          var info = Array.isArray(data) ? data[0] || {} : data;
          _this2.afterInfo = {
            rowId: info.id || info.rowId,
            problemCause: info.problemCause || '',
            problemNow: info.problemNow || '',
            problemDescription: info.problemDescription || '',
            amendmentType: info.amendmentType || '',
            requiredInboundTime: info.requiredInboundTime || '',
            requiredDeliveryDate: info.requiredDeliveryDate || '',
            requiredInstallationDate: info.requiredInstallationDate || '',
            auditRemark: info.auditRemark || '',
            serviceRemark: info.serviceRemark || '',
            serviceFile: info.serviceFile || '',
            problemImg: info.problemImg || '',
            file: info.file || '',
            otherFile: info.otherFile || '',
            changeStatus: info.changeStatus || '',
            contactPerson: info.contactPerson || '',
            contactAddress: info.contactAddress || '',
            contactNumber: info.contactNumber || '',
            subStatus: info.subStatus || '',
            assignUserName: info.assignUserName || '',
            assignNickName: info.assignNickName || '',
            payNickName: info.payNickName || '',
            payTime: info.payTime || '',
            chargeAmount: info.chargeAmount != null ? Number(info.chargeAmount) : null,
            paymentProof: info.paymentProof || '',
            payRemark: info.payRemark || '',
            receiveNickName: info.receiveNickName || '',
            receiveTime: info.receiveTime || '',
            receiveAmount: info.receiveAmount != null ? Number(info.receiveAmount) : null
          }; // 已提交的数据不允许修改

          if (info.subStatus === '已提交') {
            _this2.submitted = true;
          } // 回显跟进附件到上传列表


          _this2.serviceFileUploadList = _this2.buildUploadList(info.serviceFile, '跟进附件');
          _this2.uploadServiceFiles = _this2.parseFiles(info.serviceFile).map(function (item) {
            return JSON.stringify(item);
          }); // 回显付款凭证到上传列表

          _this2.paymentProofUploadList = _this2.buildUploadList(info.paymentProof);
          _this2.uploadPaymentProofs = _this2.parseFiles(info.paymentProof).map(function (item) {
            return JSON.stringify(item);
          }); // 合并改补接口返回的合同字段，API 数据优先，query 中非空值做补充

          var queryContract = _this2._queryContract || {}; // 合同信息可能在 info 顶层，也可能嵌套在 info.contract 对象中

          var infoContract = info.contract && (0, _typeof2.default)(info.contract) === 'object' ? info.contract : {};

          var merged = _objectSpread(_objectSpread({}, infoContract), info); // 用 query 中非空字段补充 API 缺失的字段


          Object.keys(queryContract).forEach(function (key) {
            if (queryContract[key] && !merged[key]) {
              merged[key] = queryContract[key];
            }
          });
          _this2.contract = merged; // 付款金额为空时，自动从报价接口获取总金额赋值（统计为0时也显示上去）

          if (_this2.afterInfo.chargeAmount == null) {
            var _contractNo = _this2.contract.contractNo || _this2.$route.query.contractNo;

            if (_contractNo) {
              (0, _contract.getOrderQuote)({
                contractNumber: _contractNo
              }).then(function (quoteRes) {
                if (quoteRes.code === 200 && quoteRes.data) {
                  var total = _this2.calcQuoteTotal(quoteRes.data);

                  if (_this2.afterInfo.chargeAmount == null) {
                    _this2.afterInfo.chargeAmount = Number(total.toFixed(2));
                  }
                }
              }).catch(function () {});
            }
          }
        }
      }).catch(function () {
        _this2.$message.error('加载改补信息失败');
      })); // 加载物料

      var contractNo = this.$route.query.contractNo;

      if (contractNo) {
        promises.push((0, _order.queryByContractId)({
          contractNo: contractNo
        }).then(function (response) {
          if (response.code === 200 && response.data) {
            _this2.originalMaterialList = response.data.originalList || [];
            _this2.otherMaterialList = response.data.otherList || [];
            _this2.kujialeMaterialList = response.data.KuJiaLeList || [];

            _this2.syncMaterialDeptNames();
          }
        }).catch(function () {}));
      }

      Promise.all(promises).finally(function () {
        _this2.loading = false;
      });
    },
    parseFiles: function parseFiles(val) {
      if (!val) return [];

      try {
        var parsed = typeof val === 'string' ? JSON.parse(val) : val;
        if (!Array.isArray(parsed)) return []; // 数组中每个元素可能还是 JSON 字符串

        return parsed.map(function (item) {
          if (typeof item === 'string') {
            try {
              return JSON.parse(item);
            } catch (_unused) {
              return {
                realName: item
              };
            }
          }

          return item;
        });
      } catch (_unused2) {
        return [];
      }
    },
    // 跟进附件回显列表（uploadServiceFiles 为 JSON 字符串数组）
    isImageFile: function isImageFile(file) {
      if (!file) return false;
      if (file.type === '图片') return true;
      var name = (file.localName || file.name || file.realName || file.url || '').toLowerCase();
      return /\.(png|jpe?g|gif|bmp|webp)$/.test(name);
    },
    getFileUrl: function getFileUrl(file) {
      if (file.url) return file.url;

      if (file.type === '图片') {
        return this.$store.getters.imgPreviewPrefix + file.realName;
      } // 视频文件


      if (file.type === '视频') {
        return this.$store.getters.videoPreviewPrefix + file.realName;
      } // 根据扩展名兜底判断图片


      if (this.isImageFile(file)) {
        return this.$store.getters.imgPreviewPrefix + file.realName;
      }

      return this.$store.getters.filePreviewPrefix + file.realName;
    },
    // 图片预览地址列表（用于批量预览）
    getPreviewList: function getPreviewList(val) {
      var files = this.parseFiles(val);
      var prefix = this.$store.getters.imgPreviewPrefix || '';
      return files.map(function (f) {
        return f.url || prefix + (f.realName || '');
      });
    },
    isShowDutyPerson: function isShowDutyPerson(problemType) {
      if (this.afterInfo.amendmentType === '售后单') return false;
      var hiddenTypes = ['B端原因(收费)', 'C端原因(收费)', '客情维护', '辅材耗材'];
      return !hiddenTypes.includes(problemType);
    },
    // 加载责任部门树（企业微信同步部门）
    loadDutyDeptTree: function loadDutyDeptTree() {
      var _this3 = this;

      if (this.dutyDeptTreeLoaded) return;
      (0, _syncQwDept.getQwDeptTree)().then(function (response) {
        var list = (response && response.code === 200 ? response.data : null) || [];
        _this3.dutyDeptTree = _this3.buildDeptOptions(list);
        var idName = {};
        var nameId = {};

        var walk = function walk(nodes) {
          (nodes || []).forEach(function (item) {
            if (item.deptId != null) {
              idName[item.deptId] = item.name;
              if (!(item.name in nameId)) nameId[item.name] = item.deptId;
            }

            walk(item.children);
          });
        };

        walk(list);
        _this3.dutyDeptIdNameMap = idName;
        _this3.dutyDeptNameIdMap = nameId;
        _this3.dutyDeptTreeLoaded = true; // 部门树就绪后，补全物料行中仅存 duty_dept_id 的部门名称

        _this3.syncMaterialDeptNames();
      }).catch(function () {});
    },
    // 原始部门树 -> treeselect 需要的 { id, label, children } 结构
    buildDeptOptions: function buildDeptOptions(list) {
      var _this4 = this;

      return (list || []).map(function (item) {
        return {
          id: item.deptId,
          label: item.name,
          children: _this4.buildDeptOptions(item.children)
        };
      });
    },
    // 部门名称 -> 部门ID（用于 treeselect 回显）
    deptIdByName: function deptIdByName(name) {
      if (!name) return null;
      return this.dutyDeptNameIdMap[name] != null ? this.dutyDeptNameIdMap[name] : null;
    },
    // 下拉回显值：优先用已保存的部门ID（duty_dept_id），避免同名部门回显错误
    deptSelectValue: function deptSelectValue(row) {
      if (!row) return null;
      if (row.dutyDeptId != null && row.dutyDeptId !== '') return row.dutyDeptId;
      if (row.duty_dept_id != null && row.duty_dept_id !== '') return row.duty_dept_id;
      return this.deptIdByName(row.dutyDept);
    },
    // 终判部门下拉回显值：优先用已保存的部门ID（finalDeptId）
    finalDeptSelectValue: function finalDeptSelectValue(row) {
      if (!row) return null;
      if (row.finalDeptId != null && row.finalDeptId !== '') return row.finalDeptId;
      if (row.final_dept_id != null && row.final_dept_id !== '') return row.final_dept_id;
      return this.deptIdByName(row.finalDept);
    },
    // 责任人下拉选项：未选部门时用预取的全部人员兜底；
    // 已选部门时只返回该部门人员，未加载完返回空数组。
    // 注意：不能在已选部门时回退到 ALL_USERS，否则选部门瞬间渲染全公司人员会直接卡死。
    deptUserOptions: function deptUserOptions(deptId) {
      if (deptId == null || deptId === '') return this.dutyDeptUsers.ALL_USERS || [];
      return this.dutyDeptUsers[deptId] || [];
    },
    // 按部门ID加载用户（带缓存；deptId 为空时加载全部用户）
    loadDeptUsers: function loadDeptUsers(deptId) {
      var _this5 = this;

      var key = deptId == null || deptId === '' ? 'ALL_USERS' : deptId;
      if (this.dutyDeptUsers[key]) return Promise.resolve(this.dutyDeptUsers[key]);
      if (this.dutyDeptUsersLoading[key]) return Promise.resolve([]);
      this.$set(this.dutyDeptUsersLoading, key, true);
      return (0, _syncQwDept.getQwDeptUsers)(key === 'ALL_USERS' ? undefined : deptId).then(function (response) {
        var raw = (response && response.code === 200 ? response.data : null) || [];
        var list = Array.isArray(raw) ? raw : raw.content || raw.list || raw.records || raw.rows || [];
        var options = list.map(function (item) {
          var label = item.name || item.nickName || item.nick_name || item.userName || item.user_name || '';
          var userId = item.userid != null ? item.userid : item.userId != null ? item.userId : item.id != null ? item.id : '';
          return {
            label: label,
            value: label,
            userId: userId
          };
        }).filter(function (item) {
          return item.value;
        }); // 维护 O(1) 查找映射，避免后续每次按ID/姓名反查都全量扫描

        options.forEach(function (item) {
          if (item.userId !== '' && item.userId != null) {
            _this5.$set(_this5.userIdNameMap, String(item.userId), item.label);

            if (!(item.value in _this5.userNameIdMap)) _this5.$set(_this5.userNameIdMap, item.value, item.userId);
          }
        });

        _this5.$set(_this5.dutyDeptUsers, key, options);

        return options;
      }).catch(function () {
        // 失败不缓存空结果，下次打开可重试
        return [];
      }).finally(function () {
        _this5.$set(_this5.dutyDeptUsersLoading, key, false); // 人员列表就绪后，补全只存了责任人ID的行的姓名（同一轮多次加载只跑一次）


        _this5.scheduleFillPersonNames();
      });
    },
    // 合并同一轮内的多次补全，避免每加载一个部门就整表回填/重渲染导致越选越卡
    scheduleFillPersonNames: function scheduleFillPersonNames() {
      var _this6 = this;

      if (this._fillPersonNamesPending) return;
      this._fillPersonNamesPending = true;
      this.$nextTick(function () {
        _this6._fillPersonNamesPending = false;

        _this6.fillMaterialPersonNames();
      });
    },
    // 责任人名称 -> 用户ID（先用该部门精确匹配，再用全局映射，O(1)）
    deptUserIdByName: function deptUserIdByName(deptId, name) {
      if (!name) return '';
      var deptUsers = deptId != null && deptId !== '' ? this.dutyDeptUsers[deptId] || [] : [];
      var hit = deptUsers.find(function (item) {
        return item.value === name;
      });
      if (hit) return hit.userId;
      var mapped = this.userNameIdMap[name];
      return mapped != null ? mapped : '';
    },
    // 用户ID -> 用户名称（O(1) 映射）
    userNameById: function userNameById(userId) {
      if (userId == null || userId === '') return '';
      return this.userIdNameMap[String(userId)] || '';
    },
    // 责任人/终判责任人只存了ID（后端未回传姓名）时，反查姓名保证下拉能回显
    fillMaterialPersonNames: function fillMaterialPersonNames() {
      var _this7 = this;

      var fill = function fill(list) {
        return (list || []).forEach(function (row) {
          if (!row.dutyPerson && row.dutyPersonId != null && row.dutyPersonId !== '') {
            var name = _this7.userNameById(row.dutyPersonId);

            if (name) _this7.$set(row, 'dutyPerson', name);
          }

          if (!row.finalPerson && row.finalPersonId != null && row.finalPersonId !== '') {
            var _name = _this7.userNameById(row.finalPersonId);

            if (_name) _this7.$set(row, 'finalPerson', _name);
          }
        });
      };

      fill(this.originalMaterialList);
      fill(this.otherMaterialList);
      fill(this.kujialeMaterialList);
    },
    // 行内选择责任人
    handleRowDutyPersonChange: function handleRowDutyPersonChange(row) {
      var _this8 = this;

      if (!this.canEditJudgment) return;
      var deptId = this.deptSelectValue(row);
      var personId = this.deptUserIdByName(deptId, row.dutyPerson);
      this.$set(row, 'dutyPersonId', personId);
      var rowId = row.rowId || row.id;
      if (!rowId) return;
      var data = {
        rowId: rowId,
        dutyPerson: row.dutyPerson || ''
      }; // 仅在解析到真实ID时提交，避免空串写入后端ID列导致保存失败

      if (personId !== '' && personId != null) data.duty_person_id = personId;
      (0, _designSchemeApi.editBom)(data).then(function (response) {
        if (response && response.code === 200) {
          _this8.$message.success('保存成功');
        }
      }).catch(function () {
        _this8.$message.error('保存失败');
      });
    },
    // 批量修改区选择责任人
    handleBatchDutyPersonChange: function handleBatchDutyPersonChange(formKey) {
      var form = this[formKey];
      if (!form) return; // 记录“责任人被操作过”，这样清空责任人也能下发（与未选择区分开）

      form.dutyPersonTouched = true;
      form.dutyPersonId = this.deptUserIdByName(form.dutyDeptId, form.dutyPerson);
    },
    // 是否已选择责任部门（名称或ID任一存在）
    hasBatchDutyDept: function hasBatchDutyDept(form) {
      return !!(form && (form.dutyDept || form.dutyDeptId !== '' && form.dutyDeptId != null));
    },
    // 批量修改区选择终判责任人
    handleBatchFinalPersonChange: function handleBatchFinalPersonChange(formKey) {
      var form = this[formKey];
      if (!form) return; // 记录“终判责任人被操作过”，这样清空终判责任人也能下发（与未选择区分开）

      form.finalPersonTouched = true;
      form.finalPersonId = this.deptUserIdByName(form.finalDeptId, form.finalPerson);
    },
    // 是否已选择终判部门（名称或ID任一存在）
    hasBatchFinalDept: function hasBatchFinalDept(form) {
      return !!(form && (form.finalDept || form.finalDeptId !== '' && form.finalDeptId != null));
    },
    // 批量修改表单重置（含“是否操作过责任人”的标记）
    emptyBatchForm: function emptyBatchForm() {
      return {
        problemType: '',
        dutyPerson: '',
        dutyPersonId: '',
        dutyDept: '',
        dutyDeptId: '',
        finalDept: '',
        finalDeptId: '',
        finalPerson: '',
        finalPersonId: '',
        chargeType: '',
        dutyPersonTouched: false,
        finalPersonTouched: false
      };
    },
    // 行的唯一标识，供 el-table 的 row-key / reserve-selection 使用
    rowKeyOf: function rowKeyOf(row) {
      if (!row) return '';
      if (row.rowId != null && row.rowId !== '') return 'r_' + row.rowId;
      if (row.id != null && row.id !== '') return 'i_' + row.id;
      return [row.productionOrder, row.barCode, row.code, row.name].filter(Boolean).join('_');
    },
    // 表格勾选变化（每个分组表格各自上报）
    handleMaterialSelectionChange: function handleMaterialSelectionChange(type, gIdx, rows) {
      this.$set(this.materialSelection[type], gIdx, rows || []);
    },
    // 某类物料当前勾选的全部行（跨分组合并，按 key 去重）
    selectedRowsOf: function selectedRowsOf(type) {
      var _this9 = this;

      var map = this.materialSelection[type] || {};
      var result = [];
      var seen = {};
      Object.keys(map).forEach(function (gIdx) {
        (map[gIdx] || []).forEach(function (row) {
          var key = _this9.rowKeyOf(row);

          if (seen[key]) return;
          seen[key] = true;
          result.push(row);
        });
      });
      return result;
    },
    selectedCount: function selectedCount(type) {
      return this.selectedRowsOf(type).length;
    },
    // 按类型取物料列表
    materialListByType: function materialListByType(type) {
      if (type === 'original') return this.originalMaterialList;
      if (type === 'other') return this.otherMaterialList;
      return this.kujialeMaterialList;
    },
    // 批量修改目标行：仅勾选行（未勾选不允许批量修改）
    resolveBatchRows: function resolveBatchRows(type) {
      return this.selectedRowsOf(type);
    },
    // 清空某类物料的勾选（含表格内部勾选状态）
    clearMaterialSelection: function clearMaterialSelection(type) {
      this.$set(this.materialSelection, type, {});
      this.clearMaterialTableSelection(type);
    },
    // 调用各个分组表格的 clearSelection
    clearMaterialTableSelection: function clearMaterialTableSelection(type) {
      var _this10 = this;

      var prefix = "matTable_".concat(type, "_");
      Object.keys(this.$refs).forEach(function (key) {
        if (key.indexOf(prefix) !== 0) return;
        var ref = _this10.$refs[key];
        var tables = Array.isArray(ref) ? ref : [ref];
        tables.forEach(function (table) {
          if (table && typeof table.clearSelection === 'function') table.clearSelection();
        });
      });
    },
    // 批量保存失败提示：带上后端返回的消息，便于定位字段/接口问题
    batchErrorText: function batchErrorText(error) {
      var msg = error && (error.msg || error.message);
      return msg ? "\u90E8\u5206\u4FDD\u5B58\u5931\u8D25\uFF1A".concat(msg) : '部分保存失败';
    },
    // 部门ID -> 部门名称（保存时使用名称）
    deptNameById: function deptNameById(id) {
      if (id == null || id === '') return '';
      return this.dutyDeptIdNameMap[id] || '';
    },
    // 物料行只存了 duty_dept_id 时，用部门树补全名称，保证下拉能回显
    syncMaterialDeptNames: function syncMaterialDeptNames() {
      var _this11 = this;

      // 后端未返回的字段需要显式 $set，否则 Vue2 下新增属性不具备响应式
      var ensure = function ensure(row, key, value) {
        if (row[key] === undefined) _this11.$set(row, key, value);
      };

      var fill = function fill(list) {
        return (list || []).forEach(function (row) {
          ensure(row, 'dutyPerson', '');
          ensure(row, 'dutyPersonId', '');
          ensure(row, 'dutyDept', '');
          ensure(row, 'dutyDeptId', '');
          ensure(row, 'finalPerson', '');
          ensure(row, 'finalPersonId', '');
          ensure(row, 'finalDept', '');
          ensure(row, 'finalDeptId', '');
          var id = row.dutyDeptId != null && row.dutyDeptId !== '' ? row.dutyDeptId : row.duty_dept_id;

          if (id != null && id !== '') {
            if (row.dutyDeptId == null || row.dutyDeptId === '') row.dutyDeptId = id;
            if (!row.dutyDept) row.dutyDept = _this11.deptNameById(id); // 已存部门ID的行，按需预加载该部门的责任人列表

            _this11.loadDeptUsers(id);
          }

          if ((row.dutyPersonId == null || row.dutyPersonId === '') && row.duty_person_id != null && row.duty_person_id !== '') {
            row.dutyPersonId = row.duty_person_id;
          } // 后端可能下发下划线键名，统一归一到驼峰


          if (!row.dutyDept && row.duty_dept) row.dutyDept = row.duty_dept;
          if (!row.dutyPerson && row.duty_person) row.dutyPerson = row.duty_person;
          var finalId = row.finalDeptId != null && row.finalDeptId !== '' ? row.finalDeptId : row.final_dept_id;

          if (finalId != null && finalId !== '') {
            if (row.finalDeptId == null || row.finalDeptId === '') row.finalDeptId = finalId;
            if (!row.finalDept) row.finalDept = _this11.deptNameById(finalId) || row.final_dept || ''; // 已存终判部门ID的行，按需预加载该部门的终判责任人列表

            _this11.loadDeptUsers(finalId);
          } // 后端可能下发下划线键名（final_person / final_person_id），统一归一到驼峰


          if (!row.finalDept && row.final_dept) row.finalDept = row.final_dept;
          if (!row.finalPerson && row.final_person) row.finalPerson = row.final_person;

          if ((row.finalPersonId == null || row.finalPersonId === '') && row.final_person_id != null && row.final_person_id !== '') {
            row.finalPersonId = row.final_person_id;
          }
        });
      };

      fill(this.originalMaterialList);
      fill(this.otherMaterialList);
      fill(this.kujialeMaterialList); // 后端只存/只返回责任人ID时，用人员列表反查姓名补全下拉回显

      this.fillMaterialPersonNames();
    },
    // 行内选择责任部门（同时保存部门名称 dutyDept 与部门ID duty_dept_id）
    handleRowDeptChange: function handleRowDeptChange(row, deptId) {
      var _this12 = this;

      if (!this.canEditJudgment) return; // 部门变更后原责任人不再适用，清空并按新部门加载责任人列表

      this.$set(row, 'dutyDept', this.deptNameById(deptId));
      this.$set(row, 'dutyDeptId', deptId == null ? '' : deptId);
      this.$set(row, 'dutyPerson', '');
      this.$set(row, 'dutyPersonId', '');
      this.loadDeptUsers(row.dutyDeptId);
      var rowId = row.rowId || row.id;
      if (!rowId) return;
      var data = {
        rowId: rowId,
        dutyDept: row.dutyDept || '',
        dutyPerson: ''
      };
      if (row.dutyDeptId !== '' && row.dutyDeptId != null) data.duty_dept_id = row.dutyDeptId;
      (0, _designSchemeApi.editBom)(data).then(function (response) {
        if (response && response.code === 200) {
          _this12.$message.success('保存成功');
        }
      }).catch(function () {
        _this12.$message.error('保存失败');
      });
    },
    // 行内选择终判部门（同时保存部门名称 finalDept 与部门ID finalDeptId）
    handleRowFinalDeptChange: function handleRowFinalDeptChange(row, deptId) {
      var _this13 = this;

      if (this.isReadOnly) return; // 终判部门变更后原终判责任人不再适用，清空并按新部门加载终判责任人列表

      this.$set(row, 'finalDept', this.deptNameById(deptId));
      this.$set(row, 'finalDeptId', deptId == null ? '' : deptId);
      this.$set(row, 'finalPerson', '');
      this.$set(row, 'finalPersonId', '');
      this.loadDeptUsers(row.finalDeptId);
      var rowId = row.rowId || row.id;
      if (!rowId) return;
      var data = {
        rowId: rowId,
        finalDept: row.finalDept || '',
        finalPerson: ''
      };

      if (row.finalDeptId !== '' && row.finalDeptId != null) {
        data.finalDeptId = row.finalDeptId;
        data.final_dept_id = row.finalDeptId;
      }

      (0, _designSchemeApi.editBom)(data).then(function (response) {
        if (response && response.code === 200) {
          _this13.$message.success('保存成功');
        }
      }).catch(function () {
        _this13.$message.error('保存失败');
      });
    },
    // 行内选择终判责任人
    handleRowFinalPersonChange: function handleRowFinalPersonChange(row) {
      var _this14 = this;

      if (this.isReadOnly) return;
      var deptId = this.finalDeptSelectValue(row);
      var personId = this.deptUserIdByName(deptId, row.finalPerson);
      this.$set(row, 'finalPersonId', personId);
      var rowId = row.rowId || row.id;
      if (!rowId) return;
      var data = {
        rowId: rowId,
        finalPerson: row.finalPerson || ''
      }; // 仅在解析到真实ID时提交，避免空串写入后端ID列导致保存失败

      if (personId !== '' && personId != null) {
        data.finalPersonId = personId;
        data.final_person_id = personId;
      }

      (0, _designSchemeApi.editBom)(data).then(function (response) {
        if (response && response.code === 200) {
          _this14.$message.success('保存成功');
        }
      }).catch(function () {
        _this14.$message.error('保存失败');
      });
    },
    // 批量修改区选择责任部门
    setBatchDutyDept: function setBatchDutyDept(formKey, deptId) {
      var form = this[formKey];
      if (!form) return;
      form.dutyDeptId = deptId == null ? '' : deptId;
      form.dutyDept = this.deptNameById(deptId); // 部门变更后清空已选责任人，并按新部门加载

      form.dutyPerson = '';
      form.dutyPersonId = ''; // 责任人随部门一并变化，应用时即使为空也要下发（清空）

      form.dutyPersonTouched = true;
      this.loadDeptUsers(form.dutyDeptId);
    },
    // 批量修改区选择终判部门
    setBatchFinalDept: function setBatchFinalDept(formKey, deptId) {
      var form = this[formKey];
      if (!form) return;
      form.finalDeptId = deptId == null ? '' : deptId;
      form.finalDept = this.deptNameById(deptId); // 部门变更后清空已选终判责任人，并按新部门加载

      form.finalPerson = '';
      form.finalPersonId = ''; // 终判责任人随终判部门一并变化，应用时即使为空也要下发（清空）

      form.finalPersonTouched = true;
      this.loadDeptUsers(form.finalDeptId);
    },
    handleBomFieldChange: function handleBomFieldChange(row, field) {
      var _this15 = this;

      if (!this.canEditJudgment) return;
      var rowId = row.rowId || row.id;
      if (!rowId) return;
      var data = (0, _defineProperty2.default)({
        rowId: rowId
      }, field, row[field] || '');
      (0, _designSchemeApi.editBom)(data).then(function (response) {
        if (response && response.code === 200) {
          _this15.$message.success('保存成功');
        }
      }).catch(function () {
        _this15.$message.error('保存失败');
      });
    },
    handleBatchEditOriginal: function handleBatchEditOriginal() {
      var _this16 = this;

      if (this.isReadOnly) return;
      var form = this.batchOriginalForm;
      var dutyEnabled = this.canEditJudgment;
      var hasDuty = !!(form.problemType || form.dutyPerson || form.dutyPersonTouched || this.hasBatchDutyDept(form) || form.chargeType);
      var hasFinal = !!(form.finalPerson || form.finalPersonTouched || this.hasBatchFinalDept(form));

      if (hasDuty && !dutyEnabled) {
        this.$message.warning('当前状态不可修改初判信息');
        return;
      }

      if (!hasDuty && !hasFinal) {
        this.$message.warning('请至少选择一项要修改的字段');
        return;
      } // 应用时重新解析一次责任人ID（防止未触发 change 事件时丢失）


      if (form.dutyPerson) {
        form.dutyPersonId = this.deptUserIdByName(form.dutyDeptId, form.dutyPerson);
      }

      if (form.finalPerson) {
        form.finalPersonId = this.deptUserIdByName(form.finalDeptId, form.finalPerson);
      } // 选了部门时，责任人以表单当前值为准（为空则清空）；单独清空责任人也同样下发


      var applyDutyDept = this.hasBatchDutyDept(form);
      var applyDutyPerson = applyDutyDept || !!form.dutyPerson || !!form.dutyPersonTouched;
      var applyFinalDept = this.hasBatchFinalDept(form);
      var applyFinalPerson = applyFinalDept || !!form.finalPerson || !!form.finalPersonTouched; // 目标行：必须勾选，只修改勾选行

      var targetRows = this.resolveBatchRows('original');

      if (targetRows.length === 0) {
        this.$message.warning('请先勾选要修改的物料');
        return;
      }

      var overlayKeys = this.overlayKeysOf('original', targetRows); // 先赋值到目标行上（立即显示）

      targetRows.forEach(function (row) {
        if (form.problemType) _this16.$set(row, 'problemType', form.problemType);

        if (applyDutyDept) {
          _this16.$set(row, 'dutyDept', form.dutyDept);

          _this16.$set(row, 'dutyDeptId', form.dutyDeptId);
        }

        if (applyDutyPerson) {
          _this16.$set(row, 'dutyPerson', form.dutyPerson || '');

          _this16.$set(row, 'dutyPersonId', form.dutyPersonId || '');
        }

        if (applyFinalDept) {
          _this16.$set(row, 'finalDept', form.finalDept);

          _this16.$set(row, 'finalDeptId', form.finalDeptId);
        }

        if (applyFinalPerson) {
          _this16.$set(row, 'finalPerson', form.finalPerson || '');

          _this16.$set(row, 'finalPersonId', form.finalPersonId || '');
        }

        if (form.chargeType) _this16.$set(row, 'chargeType', form.chargeType);
      }); // 记录本次赋值，刷新后回填，避免后端未回显时页面上值消失

      var overlay = this.buildBatchOverlay(form, {
        problemType: !!form.problemType,
        chargeType: !!form.chargeType,
        dutyDept: applyDutyDept,
        dutyPerson: applyDutyPerson,
        finalDept: applyFinalDept,
        finalPerson: applyFinalPerson
      }); // 再调接口保存有 rowId 的行

      var promises = [];
      targetRows.forEach(function (row) {
        var rowId = row.rowId || row.id;
        if (!rowId) return;
        var data = {
          rowId: rowId
        };
        if (form.problemType) data.problemType = form.problemType;

        if (applyDutyDept) {
          data.dutyDept = form.dutyDept;
          if (form.dutyDeptId !== '' && form.dutyDeptId != null) data.duty_dept_id = form.dutyDeptId;
        }

        if (applyDutyPerson) {
          data.dutyPerson = form.dutyPerson || '';
          if (form.dutyPersonId !== '' && form.dutyPersonId != null) data.duty_person_id = form.dutyPersonId;
        }

        if (applyFinalDept) {
          data.finalDept = form.finalDept || '';

          if (form.finalDeptId !== '' && form.finalDeptId != null) {
            data.finalDeptId = form.finalDeptId;
            data.final_dept_id = form.finalDeptId;
          }
        }

        if (applyFinalPerson) {
          data.finalPerson = form.finalPerson || '';

          if (form.finalPersonId !== '' && form.finalPersonId != null) {
            data.finalPersonId = form.finalPersonId;
            data.final_person_id = form.finalPersonId;
          }
        }

        if (form.chargeType) data.chargeType = form.chargeType;
        promises.push((0, _designSchemeApi.editBom)(data));
      });
      Promise.all(promises).then(function () {
        _this16.$message.success("\u6279\u91CF\u4FEE\u6539\u6210\u529F\uFF08".concat(targetRows.length, " \u6761\uFF09")); // 局部刷新原单物料列表


        _this16.refreshMaterialList(overlay, 'original', overlayKeys);
      }).catch(function (error) {
        _this16.$message.error(_this16.batchErrorText(error));
      });
      this.batchOriginalForm = this.emptyBatchForm();
    },
    handleBatchEditOther: function handleBatchEditOther() {
      var _this17 = this;

      if (this.isReadOnly) return;
      var form = this.batchOtherForm;
      var dutyEnabled = this.canEditJudgment;
      var hasDuty = !!(form.problemType || form.dutyPerson || form.dutyPersonTouched || this.hasBatchDutyDept(form) || form.chargeType);
      var hasFinal = !!(form.finalPerson || form.finalPersonTouched || this.hasBatchFinalDept(form));

      if (hasDuty && !dutyEnabled) {
        this.$message.warning('当前状态不可修改初判信息');
        return;
      }

      if (!hasDuty && !hasFinal) {
        this.$message.warning('请至少选择一项要修改的字段');
        return;
      } // 应用时重新解析一次责任人ID（防止未触发 change 事件时丢失）


      if (form.dutyPerson) {
        form.dutyPersonId = this.deptUserIdByName(form.dutyDeptId, form.dutyPerson);
      }

      if (form.finalPerson) {
        form.finalPersonId = this.deptUserIdByName(form.finalDeptId, form.finalPerson);
      } // 选了部门时，责任人以表单当前值为准（为空则清空）；单独清空责任人也同样下发


      var applyDutyDept = this.hasBatchDutyDept(form);
      var applyDutyPerson = applyDutyDept || !!form.dutyPerson || !!form.dutyPersonTouched;
      var applyFinalDept = this.hasBatchFinalDept(form);
      var applyFinalPerson = applyFinalDept || !!form.finalPerson || !!form.finalPersonTouched; // 目标行：必须勾选，只修改勾选行

      var targetRows = this.resolveBatchRows('other');

      if (targetRows.length === 0) {
        this.$message.warning('请先勾选要修改的物料');
        return;
      }

      var overlayKeys = this.overlayKeysOf('other', targetRows); // 先赋值到目标行上（立即显示）

      targetRows.forEach(function (row) {
        if (form.problemType) _this17.$set(row, 'problemType', form.problemType);

        if (applyDutyDept) {
          _this17.$set(row, 'dutyDept', form.dutyDept);

          _this17.$set(row, 'dutyDeptId', form.dutyDeptId);
        }

        if (applyDutyPerson) {
          _this17.$set(row, 'dutyPerson', form.dutyPerson || '');

          _this17.$set(row, 'dutyPersonId', form.dutyPersonId || '');
        }

        if (applyFinalDept) {
          _this17.$set(row, 'finalDept', form.finalDept);

          _this17.$set(row, 'finalDeptId', form.finalDeptId);
        }

        if (applyFinalPerson) {
          _this17.$set(row, 'finalPerson', form.finalPerson || '');

          _this17.$set(row, 'finalPersonId', form.finalPersonId || '');
        }

        if (form.chargeType) _this17.$set(row, 'chargeType', form.chargeType);
      }); // 记录本次赋值，刷新后回填，避免后端未回显时页面上值消失

      var overlay = this.buildBatchOverlay(form, {
        problemType: !!form.problemType,
        chargeType: !!form.chargeType,
        dutyDept: applyDutyDept,
        dutyPerson: applyDutyPerson,
        finalDept: applyFinalDept,
        finalPerson: applyFinalPerson
      }); // 再调接口保存有 rowId 的行

      var promises = [];
      targetRows.forEach(function (row) {
        var rowId = row.rowId || row.id;
        if (!rowId) return;
        var data = {
          rowId: rowId
        };
        if (form.problemType) data.problemType = form.problemType;

        if (applyDutyDept) {
          data.dutyDept = form.dutyDept;
          if (form.dutyDeptId !== '' && form.dutyDeptId != null) data.duty_dept_id = form.dutyDeptId;
        }

        if (applyDutyPerson) {
          data.dutyPerson = form.dutyPerson || '';
          if (form.dutyPersonId !== '' && form.dutyPersonId != null) data.duty_person_id = form.dutyPersonId;
        }

        if (applyFinalDept) {
          data.finalDept = form.finalDept || '';

          if (form.finalDeptId !== '' && form.finalDeptId != null) {
            data.finalDeptId = form.finalDeptId;
            data.final_dept_id = form.finalDeptId;
          }
        }

        if (applyFinalPerson) {
          data.finalPerson = form.finalPerson || '';

          if (form.finalPersonId !== '' && form.finalPersonId != null) {
            data.finalPersonId = form.finalPersonId;
            data.final_person_id = form.finalPersonId;
          }
        }

        if (form.chargeType) data.chargeType = form.chargeType;
        promises.push((0, _designSchemeApi.editBom)(data));
      });
      Promise.all(promises).then(function () {
        _this17.$message.success("\u6279\u91CF\u4FEE\u6539\u6210\u529F\uFF08".concat(targetRows.length, " \u6761\uFF09")); // 局部刷新其他物料列表


        _this17.refreshMaterialList(overlay, 'other', overlayKeys);
      }).catch(function (error) {
        _this17.$message.error(_this17.batchErrorText(error));
      });
      this.batchOtherForm = this.emptyBatchForm();
    },
    handleBatchEditKujiale: function handleBatchEditKujiale() {
      var _this18 = this;

      if (this.isReadOnly) return;
      var form = this.batchKujialeForm;
      var dutyEnabled = this.canEditJudgment;
      var hasDuty = !!(form.problemType || form.dutyPerson || form.dutyPersonTouched || this.hasBatchDutyDept(form) || form.chargeType);
      var hasFinal = !!(form.finalPerson || form.finalPersonTouched || this.hasBatchFinalDept(form));

      if (hasDuty && !dutyEnabled) {
        this.$message.warning('当前状态不可修改初判信息');
        return;
      }

      if (!hasDuty && !hasFinal) {
        this.$message.warning('请至少选择一项要修改的字段');
        return;
      } // 目标行：必须勾选，只修改勾选行


      var targetRows = this.resolveBatchRows('kujiale');

      if (targetRows.length === 0) {
        this.$message.warning('请先勾选要修改的物料');
        return;
      }

      this.batchKujialeLoading = true; // 应用时重新解析一次责任人ID（防止未触发 change 事件时丢失）

      if (form.dutyPerson) {
        form.dutyPersonId = this.deptUserIdByName(form.dutyDeptId, form.dutyPerson);
      }

      if (form.finalPerson) {
        form.finalPersonId = this.deptUserIdByName(form.finalDeptId, form.finalPerson);
      } // 选了部门时，责任人以表单当前值为准（为空则清空）；单独清空责任人也同样下发


      var applyDutyDept = this.hasBatchDutyDept(form);
      var applyDutyPerson = applyDutyDept || !!form.dutyPerson || !!form.dutyPersonTouched;
      var applyFinalDept = this.hasBatchFinalDept(form);
      var applyFinalPerson = applyFinalDept || !!form.finalPerson || !!form.finalPersonTouched;
      var overlayKeys = this.overlayKeysOf('kujiale', targetRows);
      targetRows.forEach(function (row) {
        if (form.problemType) _this18.$set(row, 'problemType', form.problemType);

        if (applyDutyDept) {
          _this18.$set(row, 'dutyDept', form.dutyDept);

          _this18.$set(row, 'dutyDeptId', form.dutyDeptId);
        }

        if (applyDutyPerson) {
          _this18.$set(row, 'dutyPerson', form.dutyPerson || '');

          _this18.$set(row, 'dutyPersonId', form.dutyPersonId || '');
        }

        if (applyFinalDept) {
          _this18.$set(row, 'finalDept', form.finalDept);

          _this18.$set(row, 'finalDeptId', form.finalDeptId);
        }

        if (applyFinalPerson) {
          _this18.$set(row, 'finalPerson', form.finalPerson || '');

          _this18.$set(row, 'finalPersonId', form.finalPersonId || '');
        }

        if (form.chargeType) _this18.$set(row, 'chargeType', form.chargeType);
      }); // 记录本次赋值，刷新后回填，避免后端未回显时页面上值消失

      var overlay = this.buildBatchOverlay(form, {
        problemType: !!form.problemType,
        chargeType: !!form.chargeType,
        dutyDept: applyDutyDept,
        dutyPerson: applyDutyPerson,
        finalDept: applyFinalDept,
        finalPerson: applyFinalPerson
      });
      var promises = [];
      targetRows.forEach(function (row) {
        var rowId = row.rowId || row.id;
        if (!rowId) return;
        var data = {
          rowId: rowId
        };
        if (form.problemType) data.problemType = form.problemType;

        if (applyDutyDept) {
          data.dutyDept = form.dutyDept;
          if (form.dutyDeptId !== '' && form.dutyDeptId != null) data.duty_dept_id = form.dutyDeptId;
        }

        if (applyDutyPerson) {
          data.dutyPerson = form.dutyPerson || '';
          if (form.dutyPersonId !== '' && form.dutyPersonId != null) data.duty_person_id = form.dutyPersonId;
        }

        if (applyFinalDept) {
          data.finalDept = form.finalDept || '';

          if (form.finalDeptId !== '' && form.finalDeptId != null) {
            data.finalDeptId = form.finalDeptId;
            data.final_dept_id = form.finalDeptId;
          }
        }

        if (applyFinalPerson) {
          data.finalPerson = form.finalPerson || '';

          if (form.finalPersonId !== '' && form.finalPersonId != null) {
            data.finalPersonId = form.finalPersonId;
            data.final_person_id = form.finalPersonId;
          }
        }

        if (form.chargeType) data.chargeType = form.chargeType;
        promises.push((0, _designSchemeApi.editBom)(data));
      });
      Promise.all(promises).then(function () {
        _this18.$message.success("\u6279\u91CF\u4FEE\u6539\u6210\u529F\uFF08".concat(targetRows.length, " \u6761\uFF09")); // 局部刷新酷家乐物料列表


        _this18.refreshMaterialList(overlay, 'kujiale', overlayKeys);
      }).catch(function (error) {
        _this18.$message.error(_this18.batchErrorText(error));
      }).finally(function () {
        _this18.batchKujialeLoading = false;
      });
      this.batchKujialeForm = this.emptyBatchForm();
    },
    // 局部刷新物料列表（原单+其他+酷家乐）；overlay 为本次赋值的字段，刷新后回填避免被覆盖
    // target 指定生效的物料表，keys 指定仅回填哪些行（勾选行）
    refreshMaterialList: function refreshMaterialList(overlay, target, keys) {
      var _this19 = this;

      var contractNo = this.$route.query.contractNo;
      if (!contractNo) return;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/cms/order'));
      }).then(function (mod) {
        return mod.queryByContractId({
          contractNo: contractNo
        });
      }).then(function (response) {
        if (response.code === 200 && response.data) {
          _this19.originalMaterialList = response.data.originalList || [];
          _this19.otherMaterialList = response.data.otherList || [];
          _this19.kujialeMaterialList = response.data.KuJiaLeList || [];

          _this19.syncMaterialDeptNames(); // 后端未回显本次修改时，用本地赋值覆盖，保证页面上能看到刚设置的值


          _this19.applyMaterialOverlay(overlay, target, keys); // 数据已替换，旧勾选行引用失效，清空该表的勾选


          if (target) _this19.clearMaterialSelection(target);
        }
      }).catch(function () {});
    },
    // 把本次批量赋值的字段回填到刷新后的行上（target 指定表，keys 指定行；为空则整表）
    applyMaterialOverlay: function applyMaterialOverlay(overlay, target, keys) {
      var _this20 = this;

      if (!overlay) return;
      var keySet = keys && keys.length ? keys : null;

      var apply = function apply(list) {
        return (list || []).forEach(function (row) {
          if (keySet && keySet.indexOf(_this20.rowKeyOf(row)) === -1) return;
          Object.keys(overlay).forEach(function (field) {
            return _this20.$set(row, field, overlay[field]);
          });
        });
      };

      if (!target || target === 'original') apply(this.originalMaterialList);
      if (!target || target === 'other') apply(this.otherMaterialList);
      if (!target || target === 'kujiale') apply(this.kujialeMaterialList);
      this.fillMaterialPersonNames();
    },
    // 勾选行的 key 列表（用于刷新后仅回填这些行）
    overlayKeysOf: function overlayKeysOf(type, targetRows) {
      var _this21 = this;

      return (targetRows || []).map(function (row) {
        return _this21.rowKeyOf(row);
      });
    },
    // 生成本次批量赋值的回填数据
    buildBatchOverlay: function buildBatchOverlay(form, flags) {
      var overlay = {};
      if (flags.problemType) overlay.problemType = form.problemType;
      if (flags.chargeType) overlay.chargeType = form.chargeType;

      if (flags.dutyDept) {
        overlay.dutyDept = form.dutyDept || '';
        overlay.dutyDeptId = form.dutyDeptId == null ? '' : form.dutyDeptId;
      }

      if (flags.dutyPerson) {
        overlay.dutyPerson = form.dutyPerson || '';
        overlay.dutyPersonId = form.dutyPersonId || '';
      }

      if (flags.finalDept) {
        overlay.finalDept = form.finalDept || '';
        overlay.finalDeptId = form.finalDeptId == null ? '' : form.finalDeptId;
      }

      if (flags.finalPerson) {
        overlay.finalPerson = form.finalPerson || '';
        overlay.finalPersonId = form.finalPersonId || '';
      }

      return overlay;
    },
    handleSave: function handleSave(subStatus) {
      var _this22 = this;

      if (!this.afterInfo.rowId) {
        this.$message.warning('缺少改补信息ID');
        return;
      }

      this.afterInfo.subStatus = subStatus;
      this.saveLoading = true; // 提交/暂存不携带确认付款、确认收款模块的内容（由 subPay/subReceive 专用接口处理）

      var data = _objectSpread(_objectSpread({}, this.buildEditAfterData()), {}, {
        subStatus: this.afterInfo.subStatus
      });

      (0, _contract.editContractAfter)(data).then(function (response) {
        if (response && response.code === 200) {
          _this22.$message.success(subStatus === '已提交' ? '提交成功' : '暂存成功');

          if (subStatus === '已提交') {
            _this22.submitted = true;
          }
        } else {
          _this22.$message.error(response.msg || '保存失败');
        }
      }).catch(function (error) {
        console.error('保存失败:', error);

        _this22.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this22.saveLoading = false;
      });
    },
    // 改补信息保存的公共字段（含跟进备注/跟进附件）
    buildEditAfterData: function buildEditAfterData() {
      return {
        rowId: this.afterInfo.rowId,
        problemCause: this.afterInfo.problemCause || '',
        problemNow: this.afterInfo.problemNow || '',
        problemDescription: this.afterInfo.problemDescription || '',
        amendmentType: this.afterInfo.amendmentType || '',
        requiredInboundTime: this.afterInfo.requiredInboundTime || '',
        requiredDeliveryDate: this.afterInfo.requiredDeliveryDate || '',
        requiredInstallationDate: this.afterInfo.requiredInstallationDate || '',
        auditRemark: this.afterInfo.auditRemark || '',
        contactPerson: this.afterInfo.contactPerson || '',
        contactAddress: this.afterInfo.contactAddress || '',
        contactNumber: this.afterInfo.contactNumber || '',
        otherFile: this.afterInfo.otherFile || [],
        assignUserName: this.afterInfo.assignUserName || '',
        assignNickName: this.afterInfo.assignNickName || '',
        serviceRemark: this.afterInfo.serviceRemark || '',
        serviceFile: this.uploadServiceFiles || []
      };
    },
    // 保存跟进备注/跟进附件（提交后仍可编辑保存）
    handleSaveService: function handleSaveService() {
      var _this23 = this;

      if (!this.afterInfo.rowId) {
        this.$message.warning('缺少改补信息ID');
        return;
      }

      this.serviceSaveLoading = true;

      var data = _objectSpread(_objectSpread({}, this.buildEditAfterData()), {}, {
        subStatus: this.afterInfo.subStatus || ''
      });

      (0, _contract.editContractAfter)(data).then(function (response) {
        if (response && response.code === 200) {
          _this23.$message.success('跟进信息保存成功'); // 同步已保存内容，避免重复提交旧值


          _this23.afterInfo.serviceFile = _this23.uploadServiceFiles.length ? JSON.stringify(_this23.uploadServiceFiles) : '';
        } else {
          _this23.$message.error(response && response.msg || '保存失败');
        }
      }).catch(function (error) {
        console.error('保存跟进信息失败:', error);

        _this23.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this23.serviceSaveLoading = false;
      });
    },
    // 确认付款（合同状态为86-待经销商确认时）
    handleConfirmPay: function handleConfirmPay() {
      var _this24 = this;

      if (!this.isDealerConfirm) return; // 付款金额必须已确认

      if (this.afterInfo.chargeAmount == null) {
        this.$message.warning('请先确认报价金额（点击"查看报价"填入）');
        return;
      } // 付款金额为0时无需上传付款凭证


      if (Number(this.afterInfo.chargeAmount) !== 0 && this.uploadPaymentProofs.length === 0) {
        this.$message.warning('请上传付款凭证');
        return;
      }

      this.$confirm('确认已付款？确认后付款信息将保存。', '确认付款', {
        confirmButtonText: '确认付款',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 弹窗确认后再填入付款人和付款时间
        var user = _this24.$store.getters.user || {};
        _this24.afterInfo.payNickName = _this24.afterInfo.payNickName || user.nickName || user.userName || '';
        _this24.afterInfo.payTime = _this24.afterInfo.payTime || _this24.formatNow();

        _this24.confirmPaySubmit();
      }).catch(function () {});
    },
    // 调用确认付款接口
    confirmPaySubmit: function confirmPaySubmit() {
      var _this25 = this;

      var rowId = this.afterInfo.rowId;

      if (!rowId) {
        this.$message.warning('缺少改补信息ID');
        return;
      }

      this.saveLoading = true;
      var data = {
        rowId: rowId,
        chargeAmount: this.afterInfo.chargeAmount == null ? '' : this.afterInfo.chargeAmount,
        paymentProof: this.uploadPaymentProofs || [],
        payNickName: this.afterInfo.payNickName || '',
        payTime: this.afterInfo.payTime || '',
        payRemark: this.afterInfo.payRemark || ''
      };
      (0, _contract.subPay)(data).then(function (response) {
        if (response && response.code === 200) {
          _this25.$message.success('确认付款成功'); // 确认付款后重新加载，获取最新的合同状态


          var contractId = _this25.$route.query.id;

          if (contractId) {
            _this25.loadData(contractId);
          }
        } else {
          _this25.$message.error(response && response.msg || '确认付款失败');
        }
      }).catch(function (error) {
        console.error('确认付款失败:', error);

        _this25.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this25.saveLoading = false;
      });
    },
    // 确认收款（付款时间不为空且收款时间为空时）
    handleConfirmReceive: function handleConfirmReceive() {
      var _this26 = this;

      // 仅已付款且未收款时可操作
      if (!this.afterInfo.payTime || this.afterInfo.receiveTime) return; // 收款金额必填

      if (this.afterInfo.receiveAmount == null) {
        this.$message.warning('请输入收款金额');
        return;
      } // 付款金额不为0时，收款金额必须大于0；付款金额为0时允许收款金额为0


      if (Number(this.afterInfo.chargeAmount) !== 0 && this.afterInfo.receiveAmount <= 0) {
        this.$message.warning('收款金额必须大于0');
        return;
      }

      this.$confirm('确认已收款？确认后收款信息将保存。', '确认收款', {
        confirmButtonText: '确认收款',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 弹窗确认后再填入收款人和收款时间
        var user = _this26.$store.getters.user || {};
        _this26.afterInfo.receiveNickName = _this26.afterInfo.receiveNickName || user.nickName || user.userName || '';
        _this26.afterInfo.receiveTime = _this26.afterInfo.receiveTime || _this26.formatNow();

        _this26.confirmReceiveSubmit();
      }).catch(function () {});
    },
    // 调用确认收款接口
    confirmReceiveSubmit: function confirmReceiveSubmit() {
      var _this27 = this;

      var rowId = this.afterInfo.rowId;

      if (!rowId) {
        this.$message.warning('缺少改补信息ID');
        return;
      }

      this.saveLoading = true;
      var data = {
        rowId: rowId,
        receiveAmount: this.afterInfo.receiveAmount == null ? '' : this.afterInfo.receiveAmount,
        receiveNickName: this.afterInfo.receiveNickName || '',
        receiveTime: this.afterInfo.receiveTime || ''
      };
      (0, _contract.subReceive)(data).then(function (response) {
        if (response && response.code === 200) {
          _this27.$message.success('确认收款成功'); // 确认收款后重新加载，获取最新的数据


          var contractId = _this27.$route.query.id;

          if (contractId) {
            _this27.loadData(contractId);
          }
        } else {
          _this27.$message.error(response && response.msg || '确认收款失败');
        }
      }).catch(function (error) {
        console.error('确认收款失败:', error);

        _this27.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this27.saveLoading = false;
      });
    },
    // 格式化当前时间为 yyyy-MM-dd HH:mm:ss
    formatNow: function formatNow() {
      var d = new Date();

      var pad = function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      };

      return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), " ").concat(pad(d.getHours()), ":").concat(pad(d.getMinutes()), ":").concat(pad(d.getSeconds()));
    },
    // 同步酷家乐物料
    handleSyncBom: function handleSyncBom() {
      var _this28 = this;

      if (!this.canEditJudgment) return;
      var contractNo = this.contract.contractNo;

      if (!contractNo) {
        this.$message.warning('缺少合同号');
        return;
      }

      this.syncBomLoading = true;
      (0, _contract.syncBomList)(contractNo).then(function (response) {
        if (response.code === 200) {
          _this28.$message.success('同步成功');

          _this28.loadKujialeMaterial(contractNo);
        } else {
          _this28.$message.error(response.msg || '同步失败');
        }
      }).catch(function () {
        _this28.$message.error('同步失败，网络错误');
      }).finally(function () {
        _this28.syncBomLoading = false;
      });
    },
    // 加载酷家乐物料
    loadKujialeMaterial: function loadKujialeMaterial(contractNo) {
      var _this29 = this;

      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/cms/order'));
      }).then(function (mod) {
        mod.queryByContractId({
          contractNo: contractNo
        }).then(function (response) {
          if (response.code === 200 && response.data) {
            _this29.kujialeMaterialList = response.data.KuJiaLeList || [];

            _this29.syncMaterialDeptNames();
          }
        }).catch(function () {});
      });
    },
    // 按 productionOrder 对物料进行分组
    groupByProductionOrder: function groupByProductionOrder(list) {
      var groups = {};
      list.forEach(function (item) {
        var key = item.productionOrder || '__无单号__';
        if (!groups[key]) groups[key] = [];
        groups[key].push(item);
      });
      return Object.entries(groups).map(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            productionOrder = _ref2[0],
            items = _ref2[1];

        return {
          productionOrder: productionOrder,
          items: items
        };
      });
    },
    // 解析昵称字段 (JSON数组)
    parseNickName: function parseNickName(val) {
      if (!val) return '';

      try {
        var arr = typeof val === 'string' ? JSON.parse(val) : val;
        return Array.isArray(arr) ? arr.join(', ') : val;
      } catch (_unused3) {
        return val;
      }
    },
    // 打开处理人（客服）选择
    openUserSelect: function openUserSelect() {
      if (!this.canEditJudgment) return;
      this.$refs.userSelect.selectType = '客服';
      this.showUserSelect = true;
    },
    // 关闭处理人选择
    onUserSelectClose: function onUserSelectClose() {
      this.showUserSelect = false;
    },
    // 处理人选择回调
    selectUserCallBack: function selectUserCallBack(user) {
      this.showUserSelect = false;
      this.afterInfo.assignUserName = user.username || '';
      this.afterInfo.assignNickName = user.nickName || '';
    },
    // 查看付款二维码
    handleViewPayQr: function handleViewPayQr() {
      this.showPayQrDialog = true;
    },
    // 点击付款金额 - 打开报价信息弹窗（仅查看报价，不受付款权限限制）
    handleOpenQuoteDialog: function handleOpenQuoteDialog() {
      var contractNo = this.contract.contractNo;

      if (!contractNo) {
        this.$message.warning('缺少合同号');
        return;
      }

      this.showQuoteDialog = true;
      this.loadQuoteData(contractNo);
    },
    // 加载报价信息
    loadQuoteData: function loadQuoteData(contractNumber) {
      var _this30 = this;

      this.quoteLoading = true;
      (0, _contract.getOrderQuote)({
        contractNumber: contractNumber
      }).then(function (response) {
        if (response.code === 200 && response.data) {
          _this30.quoteList = response.data;
          _this30.quoteTotal = _this30.calcQuoteTotal(response.data);
        } else {
          _this30.quoteList = [];
          _this30.quoteTotal = 0;
        }
      }).catch(function () {
        _this30.quoteList = [];
        _this30.quoteTotal = 0;

        _this30.$message.error('获取报价信息失败');
      }).finally(function () {
        _this30.quoteLoading = false;
      });
    },
    // 计算单个订单报价小计
    getQuoteTotal: function getQuoteTotal(quotes) {
      if (!quotes || quotes.length === 0) return 0;
      return quotes.reduce(function (sum, item) {
        return sum + (item.totalAmount || 0);
      }, 0);
    },
    // 计算报价合计（排除已取消订单）
    calcQuoteTotal: function calcQuoteTotal(list) {
      var _this31 = this;

      if (!list || list.length === 0) return 0;
      return list.reduce(function (sum, row) {
        if (row.productionStatus === '取消') return sum;
        return sum + _this31.getQuoteTotal(row.quotes);
      }, 0);
    },
    // 使用报价金额填入付款金额（仅合同状态86可操作）
    handleUseQuoteAmount: function handleUseQuoteAmount() {
      if (!this.canEditPay) {
        this.$message.warning('当前状态不可修改付款金额');
        return;
      }

      this.afterInfo.chargeAmount = Number(this.quoteTotal.toFixed(2));
      this.showQuoteDialog = false;
      this.$message.success('已填入报价金额');
    },
    // 将附件字符串转为 el-upload 回显列表（优先用完整url，兼容旧数据realName拼接）
    buildUploadList: function buildUploadList(val) {
      var fallbackLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '付款凭证';
      var files = this.parseFiles(val);
      var prefix = this.$store.getters.imgPreviewPrefix || '';
      return files.map(function (item, index) {
        return {
          name: item.name || item.localName || item.alias || item.realName || fallbackLabel + (index + 1),
          url: item.url || prefix + (item.realName || ''),
          response: item,
          status: 'success'
        };
      });
    },
    // 上传文件回调
    handleBeforeUpload: function handleBeforeUpload(file) {
      var isLt100M = file.size / 1024 / 1024 < 100;

      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过 100MB!');
        return false;
      }

      return true;
    },
    // 移除跟进附件（按索引）
    handleRemoveServiceFile: function handleRemoveServiceFile(idx) {
      var list = (this.uploadServiceFiles || []).slice();
      list.splice(idx, 1);
      this.uploadServiceFiles = list;
    },
    handleUploadSuccess: function handleUploadSuccess(type, response, file, fileList) {
      var pathStr = JSON.stringify(_objectSpread(_objectSpread({}, response), {}, {
        localName: file.name
      }));
      var listKey = type + 'UploadList';
      var dataKey = 'upload' + type.charAt(0).toUpperCase() + type.slice(1) + 's';
      this[listKey] = fileList;
      this[dataKey] = this[dataKey] || [];
      this[dataKey].push(pathStr);
    },
    handleUploadRemove: function handleUploadRemove(type, file) {
      var listKey = type + 'UploadList';
      var dataKey = 'upload' + type.charAt(0).toUpperCase() + type.slice(1) + 's';
      this[listKey] = this[listKey].filter(function (f) {
        return f.uid !== file.uid;
      });
      var targetName = file.response ? file.response.realName : '';

      if (targetName) {
        this[dataKey] = this[dataKey].filter(function (item) {
          try {
            var o = JSON.parse(item);
            return o.realName !== targetName;
          } catch (_unused4) {
            return true;
          }
        });
      } else {
        // 如果 file.response 不存在，用文件名匹配过滤
        this[dataKey] = this[dataKey].filter(function (item) {
          try {
            var o = JSON.parse(item);
            return o.localName !== file.name;
          } catch (_unused5) {
            return true;
          }
        });
      }
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
};
exports.default = _default;